// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vyU5","footer":"styles_footer__1mVCP"};